import type { TimelineRow } from './types'

import React from 'react'

import { useTimelineGridContext } from './TimelineGridContext'

export default function TimelineGridLeftPane<T>({
	components: { PaneRowContent },
}: {
	components: {
		PaneRowContent: <T>({ row }: { row: TimelineRow<T> }) => React.ReactNode
	}
}) {
	const { rows, viewportHeight: height } = useTimelineGridContext<T>()

	return (
		<div
			className='border-base sticky left-0 z-50 w-[384px] border-r border-b border-solid bg-background'
			style={{ height }}
		>
			<div className='border-base sticky top-0 z-40 h-10 border-b border-solid bg-secondary' />
			{rows.map((row) => (
				<div
					className='border-base flex h-20 items-center border-b border-solid px-4'
					key={row.id}
				>
					<PaneRowContent<T> row={row} />
				</div>
			))}
		</div>
	)
}
